import React, { Fragment, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Table from './Table';
import ToggledRow from './ToggledRow';
import { useMediaQuery } from 'react-responsive/src';
import Title from './table/Title';
import TableCellText from './TableCellText';
import { Button } from 'react-bootstrap';

export default function CourseRunList(props) {
  let { courseRunList, title, pageParamName, count, currentPage, onPageChange, columns, hasEdit = false } = props;

  let [showCols, setShowCols] = useState({
    name: true,
    short_description: false,
    translated_status: false,
    actions: false,
    more: true,
  });

  let isMDScreen = useMediaQuery({ query: '(min-width: 768px)' });
  let isXLScreen = useMediaQuery({ query: '(min-width: 1200px)' });

  // Toggled row to parents (used in mobile and tablet version)
  function toggledRow(row, visibleCols) {
    let fullRowValues = { ...row.original };
    let items = {
      ...(!visibleCols.name && { name: 'نام دوره' }),
      ...(!visibleCols.short_description && { short_description: 'توضیح کوتاه دوره' }),
      ...(!visibleCols.translated_status && { translated_status: 'وضعیت درخواست' }),
    };
    return (
      <Fragment>
        <ToggledRow rowValues={fullRowValues} items={items} />
        {!visibleCols.actions && row.original.is_draft && (
          <div className={'d-flex justify-content-center'}>
            <Link to={`/courses/${fullRowValues.id}`}>
              <Button>
                <i className="fas fa-pen" />
                ویرایش
              </Button>
            </Link>
          </div>
        )}
      </Fragment>
    );
  }

  useEffect(() => {
    let newToggleCols = { ...showCols };

    let conditionalCols = [];
    if (hasEdit) conditionalCols.push('actions');

    // toggle cols => more, group_name, phone_number
    let xsShowCols = ['more'];
    let xsHideCols = ['short_description', 'translated_status', ...conditionalCols];

    let mdShowCols = ['translated_status', ...conditionalCols, 'more'];
    let mdHideCols = ['short_description'];

    let xlShowCols = ['short_description', 'translated_status', ...conditionalCols];
    let xlHideCols = ['more'];

    setShowCols(newToggleCols);
    /* eslint-disable-next-line */
  }, [isMDScreen, isXLScreen]);

  return (
    <Fragment>
      <Title value={title} />
      <Table
        data={courseRunList.data}
        /* eslint-disable-next-line */
        columns={columns}
        hasPagination={false}
        loading={courseRunList.isLoading}
        count={count}
        toggledRow={toggledRow}
        showToggledRow={!isXLScreen}
        toggledRowProps={showCols}
        currentPage={currentPage}
        onPageChange={onPageChange}
        pageParamName={pageParamName}
      />
    </Fragment>
  );
}

CourseRunList.propTypes = {
  courseRunList: PropTypes.shape({
    data: PropTypes.array,
    isLoading: PropTypes.bool,
  }).isRequired,
  count: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  hasEdit: PropTypes.bool,
};
